import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { VehiclesApiServiceMock } from '@mocks/vehicles-api-mock.service';
import { VehiclesApiService } from '../vehicles-api.service';
import { VehiclesRepository } from '../vehicles.repository';

export const HTTP_VEHICLES_SERVICE = new InjectionToken<VehiclesRepository>('VehiclesRepository');

export const VEHICLES_API_PROVIDER: Provider = {
    provide: HTTP_VEHICLES_SERVICE,
    useClass: environment.useMocks && environment.useMocks.rucVehicles ? VehiclesApiServiceMock : VehiclesApiService,
};
